import React, { Dispatch, SVGProps } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  SvgIcon,
  DialogTitle,
  DialogContentText,
  SvgIconProps,
} from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import QuillLocalStorage from 'core/utils/localStorageClient';
import QuillEditor, { QuillEditorIDS } from 'src/_common/handlers/quillEditor';
import { Tooltip } from 'src/researcher/component/common';
import { CopyFullTextTooltip } from 'src/researcher/constants/message.constants';
import { copyAllIcon } from '../../../../public/images/svgPath.json';

const useStyles = makeStyles((theme) => ({
  root: {
    color: '#5F6368',
    '&:hover': {
      backgroundColor: 'inherit',
      color: theme.palette.primary.main,
    },
  },
  toolTipBackground: {
    backgroundColor: '#2d2d2d',
  },
  arrow: {
    color: '#2d2d2d',
  },
}));

interface IProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onModalClose: Function;
  showModal: boolean;
  // classes?: Record<string, string>;
}

export function CopyDialog(props: { open?: boolean; onClose?: Function }) {
  const getOutputHtml = () =>
    QuillEditor.getInstance(QuillEditorIDS.RESEARCH_EDITOR)?.getContent() || '';
  return (
    <Dialog maxWidth="md" open={Boolean(props.open)} aria-labelledby="max-width-dialog-title">
      <DialogTitle id="max-width-dialog-title">Manually Copy Text To Your Clipboard</DialogTitle>
      <DialogContent>
        {/* @TODO: Check if it works */}
        <DialogContentText>
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: getOutputHtml(),
            }}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props?.onClose?.()} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export function CopyIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path fill="inherit" {...copyAllIcon} />
    </SvgIcon>
  );
}

function CopyAllBtn(props: IProps) {
  const classes = useStyles(props);

  return (
    <div>
      <Tooltip
        arrow
        title={
          QuillLocalStorage.getInstance().get('showToolTips', 'true') === 'true'
            ? CopyFullTextTooltip
            : ''
        }
      >
        <IconButton onClick={props.onClick} classes={{ root: classes.root }} size="large">
          <CopyIcon />
          <CopyDialog open={props.showModal} onClose={props.onModalClose} />
        </IconButton>
      </Tooltip>
    </div>
  );
}

export default CopyAllBtn;
